module.exports = __webpack_public_path__ + "img/copper-refrescador-icon.b35f3ee8.svg";